import React from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BLACK = "#0A0A0A";

export const LIME = "#5f8f10";

export const Num = ({ children, className = "" }) => (
  <span className={`inline-flex items-center justify-center bg-[#5f8f10] px-3 py-1.5 font-display text-2xl leading-none text-black md:text-3xl ${className}`}>
    {children}
  </span>
);

export const HeroToggleMark = ({ active }) => (
  <div className="relative mx-auto flex aspect-square w-full max-w-[460px] items-center justify-center transition-transform duration-300 group-hover:scale-[1.03]">
    <img
      src="/assets/toggle-off.png"
      alt=""
      aria-hidden
      className={`absolute inset-0 m-auto h-auto w-full max-w-[440px] object-contain transition-opacity duration-500 ${active ? "opacity-0" : "opacity-100"}`}
    />
    <img
      src="/assets/toggle-on.png"
      alt=""
      aria-hidden
      className={`absolute inset-0 m-auto h-auto w-full max-w-[440px] object-contain transition-opacity duration-500 ${active ? "opacity-100" : "opacity-0"}`}
    />
  </div>
);

export const BgDepth = () => (
  <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
    <div
      className="absolute inset-0 bg-dot-light opacity-70"
      style={{
        WebkitMaskImage: "radial-gradient(ellipse at 55% 25%, black 25%, transparent 78%)",
        maskImage: "radial-gradient(ellipse at 55% 25%, black 25%, transparent 78%)",
      }}
    />
    <div className="absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-[#5f8f10] opacity-[0.09] blur-[140px]" />
  </div>
);

export const HeroFrame = ({ active, pulse }) => {
  const bars = [
    { x: 20, offY: 40, h: 70 },
    { x: 96, offY: -30, h: 110 },
    { x: 172, offY: 60, h: 150 },
    { x: 248, offY: -10, h: 200 },
    { x: 324, offY: 30, h: 250 },
  ];
  return (
    <svg viewBox="0 0 400 320" className="h-full w-full">
      {active && (
        <path
          key={pulse}
          className={pulse > 0 ? "switch-draw" : ""}
          d="M45 250 L121 210 L197 160 L273 100 L349 40"
          fill="none"
          stroke={LIME}
          strokeWidth="4"
          strokeLinecap="square"
        />
      )}
      {bars.map((b, i) => {
        const baseY = 280 - b.h;
        const y = active ? 0 : b.offY;
        const rot = active ? 0 : i % 2 ? 4 : -4;
        return (
          <g key={i} transform={`translate(0 ${y}) rotate(${rot} ${b.x + 26} 280)`}>
            <rect x={b.x} y={baseY} width="52" height={b.h} fill={active ? "#FFFFFF" : BLACK} opacity={active ? 1 : 0.6} />
            {active && (
              <rect
                key={`${pulse}-${i}`}
                className={pulse > 0 ? "switch-pop" : ""}
                style={pulse > 0 ? { animationDelay: `${240 + i * 55}ms` } : undefined}
                x={b.x + 20}
                y={baseY - 12}
                width="12"
                height="12"
                fill={LIME}
              />
            )}
          </g>
        );
      })}
    </svg>
  );
};

export const MODEL_STEPS = [
  { n: "01", title: "Diagnose before prescribing", caption: "We look beyond the visible symptom to identify the real constraint affecting growth." },
  { n: "02", title: "Build strategy around execution", caption: "The strategy accounts for the people, economics, capabilities, systems and decisions required to make it happen." },
  { n: "03", title: "Bring the right expertise around one agenda", caption: "The problem determines which disciplines come together, not the service structure of the company advising you." },
  { n: "04", title: "Stay through implementation", caption: "We work with leadership, internal teams and existing partners until the agreed priorities move into action." },
];

/* Slim vertical trajectory: one rising green line with a node for each of the
   four moves. Stretches to the full height of the steps column. */

export const TrajectorySpine = () => (
  <div className="relative h-full min-h-[420px] w-full" aria-hidden>
    {/* rising green line, full height */}
    <div className="absolute bottom-3 left-1/2 top-2 w-[3px] -translate-x-1/2 bg-[#5f8f10]" />
    {/* arrowhead at bottom, pointing down */}
    <div className="absolute bottom-0 left-1/2 -translate-x-1/2" style={{ borderLeft: "7px solid transparent", borderRight: "7px solid transparent", borderTop: "12px solid #5f8f10" }} />
    {/* one node per move */}
    {[10, 37, 63, 90].map((top, i) => (
      <div key={i} className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2" style={{ top: `${top}%` }}>
        <span className="block h-3.5 w-3.5 bg-[#5f8f10]" />
        <span className="absolute -inset-1.5 border border-[#5f8f10]/35" />
      </div>
    ))}
  </div>
);

export const SITUATION_HREF = {
  "Growth Has Stalled": "/what-we-solve/growth-has-stalled",
  "Ready to Scale": "/what-we-solve/ready-to-scale",
  "Reposition & Transform": "/what-we-solve/reposition-or-transform",
  "Create Enterprise Value": "/what-we-solve/create-enterprise-value",
};

export const WORK_IMAGES = ["/assets/work-trajectory.jpg", "/assets/work-converge.jpg", "/assets/work-grid.jpg"];

